const RegisterOrderLanding = () =>
  import(
    /* webpackChunkName: "register-order" */ '@/pages/register-order/index.vue'
  )
const RegisterOrderWrapper = () =>
  import(
    /* webpackChunkName: "register-order" */ '@/pages/register-order/_type/index.vue'
  )

export default {
  path: 'register-order',
  meta: { label: 'RegisterOrder' },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'RegisterOrder',
      path: '',
      meta: { label: 'registerOrder' },
      component: RegisterOrderLanding,
      props: true
    },
    {
      name: 'RegisterOrderOperation',
      path: ':type/',
      meta: { label: 'registerOrder' },
      component: RegisterOrderWrapper,
      props: true
    }
  ]
}
